import React from 'react';

import {
	VideoFullscreenIcon,
	VideoPrintScreenIcon,
} from '@icons';

import './video.scss';

interface VideoProps extends React.HTMLProps<HTMLVideoElement> {
	videoRef: React.MutableRefObject<HTMLVideoElement>,
	onVideoFullscreenToggle: () => void,
	onVideoPrintScreen: () => void,
	src: string,
}

function Video(props: VideoProps): JSX.Element {
	const {
		onVideoFullscreenToggle,
		onVideoPrintScreen,
		videoRef,
		src,
		...videoProps
	} = props;

	return (
		<div className="video">
			<video ref={videoRef} {...videoProps}>
				<source src={src} />
			</video>
			<div className="video__controls">
				<VideoFullscreenIcon onClick={onVideoFullscreenToggle} />
				<VideoPrintScreenIcon onClick={onVideoPrintScreen} />
			</div>
		</div>
	);
}

const MemoisedVideo = React.memo(Video);

export {MemoisedVideo as Video};